/* istanbul ignore file */
import { LinkButton } from 'framework/ui/ui-builder';
import { useWasteUrl } from 'domain/shared/waste';

const ViewWasteButton = (props: any) => {
  const { getSingleEntityUrl } = useWasteUrl();

  return (
    <LinkButton url={getSingleEntityUrl} key="view-waste-entry" outline {...props}>
      View
    </LinkButton>
  );
};

export default ViewWasteButton;
